import * as Types from "../../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetOrganisationQueryVariables = Types.Exact<{
  id: Types.Scalars["Int"];
  businessUnitSearch?: Types.Maybe<Types.Scalars["String"]>;
}>;

export type GetOrganisationQuery = { __typename?: "query_root" } & {
  organisations_by_pk?: Types.Maybe<
    { __typename?: "organisations" } & Pick<
      Types.Organisations,
      "id" | "name" | "short_name" | "demo_dashboard"
    > & {
        image?: Types.Maybe<
          { __typename?: "uploads" } & Pick<Types.Uploads, "s3_key">
        >;
        organisation_reports: Array<
          { __typename?: "organisation_reports" } & Pick<
            Types.Organisation_Reports,
            "id" | "report_title" | "report_date"
          > & { upload: { __typename?: "uploads" } & Pick<Types.Uploads, "id"> }
        >;
        business_units: Array<
          { __typename?: "business_units" } & Pick<
            Types.Business_Units,
            "id" | "name"
          > & {
              currency_books_aggregate: {
                __typename?: "currency_books_aggregate";
              } & {
                aggregate?: Types.Maybe<
                  { __typename?: "currency_books_aggregate_fields" } & Pick<
                    Types.Currency_Books_Aggregate_Fields,
                    "count"
                  >
                >;
              };
            }
        >;
      }
  >;
};

export const GetOrganisationDocument = gql`
  query GetOrganisation($id: Int!, $businessUnitSearch: String) {
    organisations_by_pk(id: $id) {
      id
      name
      short_name
      demo_dashboard
      image {
        s3_key
      }
      organisation_reports {
        id
        report_title
        report_date
        upload {
          id
        }
      }
      business_units(
        where: {
          _and: [
            { is_archived: { _eq: false } }
            { name: { _ilike: $businessUnitSearch } }
          ]
        }
      ) {
        id
        name
        currency_books_aggregate {
          aggregate {
            count
          }
        }
      }
    }
  }
`;

export function useGetOrganisationQuery(
  options: Omit<Urql.UseQueryArgs<GetOrganisationQueryVariables>, "query"> = {}
) {
  return Urql.useQuery<GetOrganisationQuery>({
    query: GetOrganisationDocument,
    ...options,
  });
}
